<div class="h-15x flex w-full flex-col items-center justify-center">
    <button
        class="w-full py-0"
        #rla="routerLinkActive"
        [routerLinkActive]="['active-link']"
        [ngClass]="
            rla.isActive && !mobileMenuOpen
                ? 'pn-app-light:text-white orb-app-light:text-white var-app-light:text-secondary sr-app-light:text-white vl-app-light:text-white tickets-active-outline-color-stroke tickets-active-inner-ticket-color journey-planner-active-inner-color journey-planner-outline-color tickets-active-inner-ticket-fill explore-active-icon-color text-primary dark:text-contrast-yellow'
                : 'pn-app-light:text-pink-muted orb-app-light:text-white var-app-light:text-[var(--color-primary)] sr-app-light:text-green-fresh vl-app-light:text-white text-old_silver tickets-active-outline-color-stroke journey-planner-outline-color dark:text-contrast-yellow dark:opacity-50'
        "
        [attr.role]="role"
        (keydown.enter)="handleKeyboardActivate($event)"
        (keydown.space)="handleKeyboardActivate($event)"
        (keydown.tab)="handleTabNavigation($event)"
        tabindex="0"
        attr.aria-label="{{ label + '. ' + ('DOUBLE_TAP_TO_ACTIVATE' | translate) }}">
        <div class="flex flex-col items-center justify-center" aria-hidden="true">
            <div class="flex h-6 items-center">
                <ng-content select="[icon]"></ng-content>
            </div>

            <div
                class="vl-app-light:whitespace-nowrap var-app-light:text-grey-dark menu-text mt-1 text-xs font-bold dark:whitespace-nowrap">
                <ng-content select="[title]"></ng-content>
            </div>
        </div>
    </button>
</div>
